








import { AnswerContent } from '@/resource/question/question.type';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    ComponentSubjective: () =>
      import(
        '@/components/questions/subjective-components/ComponentSubjective.vue'
      ),
  },
})
export default class SubjectiveAnswer extends Vue {
  @Prop({ required: true })
  content!: AnswerContent;
}
